import { Directive, HostListener, Input } from '@angular/core';

type ArrowNavHandler = () => void;

@Directive({
  selector: '[fcArrowNavigation]',
  standalone: true,
})
export class ArrowNavigationDirective {
  @Input('fcArrowNavigationNext') next?: ArrowNavHandler;
  @Input('fcArrowNavigationPrev') prev?: ArrowNavHandler;

  @HostListener('window:keydown', ['$event'])
  handleKeydown(event: KeyboardEvent): void {
    if (!this.shouldHandle(event)) return;

    if (event.key === 'ArrowLeft') {
      this.prev?.();
    } else if (event.key === 'ArrowRight') {
      this.next?.();
    }
  }

  private shouldHandle(event: KeyboardEvent): boolean {
    const target = event.target as HTMLElement | null;
    if (!target) return true;

    const tagName = target.tagName?.toLowerCase();
    const editable =
      tagName === 'input' ||
      tagName === 'textarea' ||
      tagName === 'select' ||
      target.isContentEditable;

    return !editable;
  }
}
